import * as types from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
  _role: {},
  roleDetail: null,
};

const role = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_ROLES_LIST_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta,
      };

    case types.GET_ROLE_RESPONSE:
      return {
        ...state,
        roleDetail: action.payload,
      };
    case types.GET_SINGLE_ROLE_RESPONSE:
      return {
        ...state,
        _role: action.payload,
      };

    default:
      return state;
  }
};
export default role;
